import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["size", "style", "fallback", "className", "square", "noCorner", "blank", "checked", "url", "badge"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './styles.sass';
import Icon from '../../components/Icon';
import { match } from '../../utils/patternMatchUtil';

/**
 * Avatar component with support for fallback images.
 */
var Avatar = /*#__PURE__*/function (_React$Component) {
  function Avatar() {
    var _this;
    _classCallCheck(this, Avatar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Avatar, [].concat(args));
    _this.state = {
      usingFallback: false
    };
    _this.onError = function () {
      if (!_this.state.usingFallback) {
        _this.setState({
          usingFallback: true
        });
      }
    };
    return _this;
  }
  _inherits(Avatar, _React$Component);
  return _createClass(Avatar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        size = _this$props.size,
        style = _this$props.style,
        fallback = _this$props.fallback,
        className = _this$props.className,
        square = _this$props.square,
        noCorner = _this$props.noCorner,
        blank = _this$props.blank,
        checked = _this$props.checked,
        _url = _this$props.url,
        badge = _this$props.badge,
        props = _objectWithoutProperties(_this$props, _excluded);
      var _this$state = this.state,
        usingFallback = _this$state.usingFallback,
        url = _this$state.url;
      return /*#__PURE__*/React.createElement("div", {
        className: "avatarContainer"
      }, /*#__PURE__*/React.createElement("div", _extends({
        /* eslint-disable-next-line */
        onError: this.onError,
        className: cx('Avatar', className, blank && 'Avatar__blank', square && 'Avatar__square', noCorner && 'Avatar__noCorner'),
        style: _objectSpread({
          backgroundImage: "url('".concat(usingFallback && fallback ? fallback : url, "')"),
          width: size,
          height: size,
          minHeight: size,
          minWidth: size
        }, style)
      }, props)), match(badge, {
        Offline: function Offline() {
          return /*#__PURE__*/React.createElement("span", {
            className: cx('badge', 'offline'),
            "data-test": "presence-indicator-false"
          });
        },
        Online: function Online() {
          return /*#__PURE__*/React.createElement("span", {
            className: cx('badge', 'online'),
            "data-test": "presence-indicator-true"
          });
        },
        CheckMark: function CheckMark() {
          return /*#__PURE__*/React.createElement("div", {
            className: cx('badge', 'icon', 'checked')
          }, /*#__PURE__*/React.createElement(Icon, {
            material: true,
            size: 8,
            name: "check"
          }));
        },
        Approved: function Approved() {
          return /*#__PURE__*/React.createElement("div", {
            className: cx('badge', 'icon', 'approved')
          }, /*#__PURE__*/React.createElement(Icon, {
            material: true,
            size: 8,
            name: "check"
          }));
        },
        Declined: function Declined() {
          return /*#__PURE__*/React.createElement("div", {
            className: cx('badge', 'icon', 'declined')
          }, /*#__PURE__*/React.createElement(Icon, {
            material: true,
            size: 8,
            name: "close"
          }));
        },
        undefined: function undefined() {
          return /*#__PURE__*/React.createElement(React.Fragment, null);
        }
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.url === nextProps.url) {
        return null;
      }
      return {
        url: nextProps.url,
        usingFallback: false
      };
    }
  }]);
}(React.Component);
export { Avatar as default };
Avatar.propTypes = {
  url: PropTypes.string,
  size: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
  fallback: PropTypes.string,
  square: PropTypes.bool,
  noCorner: PropTypes.bool
};
//# sourceMappingURL=index.js.map
